//Master Data
const masterTableFields = [
    {title: "User Id",
        is_searchable: true,
        class_name: 'w-110p',
        field: {
            type: "number",
            name: "user_id"
        },
        fetch_key: "user_id"
    },
    {title: "GLOSCO Year",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "glosco_level_id"
        },
        option_label: "label",
        option_val: "id",
        fetch_key: "level_name"
    },
    {title: "GLOSCO Expiry Date",
        is_searchable: true,
        field: {
            type: "select",
            name: "validity_id"
        },
        option_label: "validity",
        option_val: "id",
        fetch_key: "expiry_at",
        data_type: {
            type: "expiry_at"
        }
    },
    {title: "Name",
        is_searchable: true,
        field: {
            type: "text",
            name: "name"
        },
        fetch_key: "name"
    },
    {title: "School",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "school_id"
        },
        accessRoleIds: [2, 7],
        option_label: "school_name",
        option_val: "id",
        fetch_key: "school_name"
    },
    {title: "Branch",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "branch_id"
        },
        accessRoleIds: [2, 7],
        option_label: "branch_name",
        option_val: "id",
        fetch_key: "branch_name"
    },
    {title: "Class",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "class_id"
        },
        option_label: "class_name",
        option_val: "id",
        fetch_key: "class_name"
    },
    {title: "Email",
        is_searchable: true,
        field: {
            type: "text",
            name: "email"
        },
        // fetch_key: "email"
        fetch_key: "user.user_email.email"
    }
];

const fieldValuesYear = {
    user_ids: '',
    year_id: '',
    user_ids_array: []
};

const fieldUpdateYear = [
    {colMd: "4", label: "Year/Level", required: true, type: "select", name: "year_id", placeholderData: ["Select Year/Level"]},
    {colMd: "8", label: "User Ids", required: true, type: "text", name: "user_ids", placeholderData: ["Ids Separated by comma, Ex: 123,456,789"]},
];

const fieldValidationYear = {
    year_id: 'required||Year/Level',
    user_ids: 'required||User Ids'
};

export {
    masterTableFields,
    fieldValuesYear,
    fieldUpdateYear,
    fieldValidationYear
};